import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=7452ec3d&scoped=true&"
import script from "./address-form.vue?vue&type=script&lang=js&"
export * from "./address-form.vue?vue&type=script&lang=js&"
import style0 from "./address-form.vue?vue&type=style&index=0&id=7452ec3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452ec3d",
  null
  
)

export default component.exports